import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";


import Breadcrumbs from "../../../../components/Breadcrumbs";
import { Button } from "components/Button";

import AssetListFilter from "./../components/AssetListFilter";
import { Table, Pagination,  } from "antd";
import {
  itemRender,
  pageSizeOptions,
} from "utils/table";
import {formatDateHandler2} from "utils/common"

import { SkeltonLoader } from "components/skeltonLoader";
import AssetFilterDrawer from "components/Drawer/assetFilterDrawer";
import { useAssets } from "./../context/assetContext";
import {  toast, Bounce } from 'react-toastify';
import { returnAssetApi } from "api/services/assets";
import ReturnAssetModal from "components/modelpopup/ReturnAssetModal";
import AllAssetAddPopup from "components/modelpopup/AllAssetAddPopup";
import Image from "components/Image";
import { useSelector } from "react-redux";

const AllAssets = () => {
  const {
    loading,
    searchText,
    assetData,
    view,
    setView,
    assetModal,
    setAssetModal,
    pageSettings,
    handleGridChange,
    handleChange,
    handleSearchChange,
    handleFilterDrawer,
    showFilterDrawer,

    handleFilterChange,
    filters,
    handleInputChange,
    handleApplyFilter,
    filterLoading,
    
    handleAssetDetailPage,
    handleDateChange,
    getAssetList,
    setLoading,
    assetCategory
  
  } = useAssets();

const [returnAssetModal, setReturnAssetModal] = useState(false)
const [selectedAsset, setSelectedAsset] = useState()

const {
  user,
  userLoading
} = useSelector((state) => state.user);


const columns = [
    {
      title: "Asset Id",
      dataIndex: "id",
      render: (text, record) => (
        <span className="table-avatar">
          {record.id}
        </span>
      )  ,
       sorter: true,
    },
   
  
    {
      title: "Name",
      dataIndex: "name",
      sorter: true,
      render: (text, record, index) => (
        <h2 onClick={()=>handleAssetDetailPage(record.id, index)} className="table-avatar d-flex">
          <a className="avatar">
            <Image 
              src={record?.image} 
              type="object" 
              style={{ 
                width: "40px", 
                height: "40px", 
                objectFit: "contain", 
                borderRadius: "4px" 
              }}
            />
          </a>
          <div>
            <a className="profile-split d-flex flex-column">
              {record.name} 
            </a>
            <small className="table-avatar">
              {record.class_code}
            </small>
          </div>
        </h2>
      )       
    },
    {
      title: "Brand",
      dataIndex: "brand",
      sorter: true,
      render: (text, record) => (
        <div className="dropdown action-label text-center">
        <span className={`badge badge-soft-warning`}>{text}</span>  

  </div>
      )   
    },
    {
      title: "Serial  No",
      dataIndex: "serial_number",
      sorter: true,
  //     render: (text, record) => (
  //       <div className="dropdown action-label text-center">
  //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // </div>
  //     )   
    },
   

    {
      title: "Current Owner",
      dataIndex: "current_user",
      sorter: true,
      render: (text, record) => (
        <h2
        //  onClick={()=>handleAssetDetailPage(record.id, index)} 
          className="table-avatar d-flex">
            {
              !!record?.current_owner&&
              <>
                <a 
        
        className="avatar">
          {/* <img alt="" src={record.profile_image} /> */}
          <Image src={record?.current_owner?.company_user?.profile_image}  type="object"/>
        </a>
        <div>
        <a 
        // onClick={()=>handleEmployeeDetailPage(record.id, index)} 
        className="profile-split d-flex flex-column">
         {record?.current_owner?.company_user?.first_name} {record?.current_owner?.company_user?.last_name} 
        </a>
        <small className="table-avatar">
      {record?.current_owner?.company_user?.emp_no }
     </small> 

      
        </div>

              </>
            }
      
      </h2>
      )   
    },
    // {
    //   title: "Return Date",
    //   dataIndex: "return_date",
    //   sorter: true,
    //   align:"center",
    //   render: (text, record) => 
    //       <>{
    //         formatDateHandler2( record?.return_date) || "-"
    //         }</>,
    // },
    // {
    //   title: "Next Approver",
    //   dataIndex: "next_approver",
    //   sorter: true,
    //   align:"center",
    //   render: (text, record) => 
    //       <>{
    //         record?.next_approver || "N/A"
    //         }</>,
    // },
  
    {
      title: "Purchase Date",
      dataIndex: "purchase_date",
      sorter: true,
      align:"center",
      render: (text, record) => 
          <>{
            formatDateHandler2( record?.purchase_date) || "-"
            }</>,
    },
    {
      title: "Purchase Value",
      dataIndex: "purchase_value",
      sorter: true,
  //     render: (text, record) => (
  //       <div className="dropdown action-label text-center">
  //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // </div>
  //     )   
    },
  //   {
  //     title: "FA No",
  //     dataIndex: "ext_id",
  //     sorter: true,
  // //     render: (text, record) => (
  // //       <div className="dropdown action-label text-center">
  // //       <span className={`badge badge-soft-pending`}>{text}</span>  

  // // </div>
  // //     )   
  //   },
    // {
    //   title: "Description",
    //   dataIndex: "description",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.description}
    //     </span>
    //   )   
    // },

    // {
    //   title: "User",
    //   dataIndex: "first_name",      
    //   render: (text, record, index) => (
    //     <h2>
    //      <a onClick={()=>handleAssetDetailPage(record.id, index)} className="profile-split d-flex flex-column">
    //     {record.company_user.first_name} {record.company_user.last_name}  <span className="table-avatar">
    //       {record.company_user.position_name }
    //     </span> 
    //   </a>    
    //   </h2>
    //   )   
    // },
   
   
    // {
    //   title: "Issue Date",
    //   dataIndex: "issue_date",
    //   render: (text, record) => 
    //   <>{
    //     formatDateHandler2( record?.issue_date)
    //     }</>,
  
    // },
    // {
    //   title: "Return Date",
    //   dataIndex: "return_date",
    //   render: (text, record) => <>{formatDateHandler2(record?.return_date)}</>,
  
    // },
    
   
    // {
    //   title: "Comments",
    //   dataIndex: "comments",
    //   sorter: true,
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       {record.comments }
    //     </span>
    //   )  
    // },

     {
          title: "Action",
          render: (text , record) => (
            <div className="dropdown dropdown-action text-end">
              <Link
                to="#"
                className="action-icon dropdown-toggle"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="material-icons">more_vert</i>
              </Link>
              
                  <div className="dropdown-menu dropdown-menu-right">
                  {/* <Link
                  onClick={()=>{
                    handleEditDocument(recort)
                    setDocumentModal(true)
                    // setSelectedDocument(record)
      
                  }}
                    // to="#"
                    className="dropdown-item"
                    // data-bs-toggle="modal"
                    // data-bs-target="#edit_job"
                  >
                    <i className="fa fa-pencil m-r-5" /> Edit
                  </Link> */}
                  {
                    console.log(user?.role?.access_scope, "((((")
                  }
                  {
                    (user?.role?.access_scope === "all" && !!record?.current_owner) && (
                      <Link
                  onClick={()=>{
                    setReturnAssetModal(true)
                  //   setAssetModal(true)
                    setSelectedAsset(record)
                  //    console.log("clic")
                   }
                
                  }
                    to="#"
                    className="dropdown-item"
                    // data-bs-toggle="modal"
                    // data-bs-target="#delete"
                  >
                    <i className="fa fa-trash m-r-5" /> Return Asset
                  </Link>
                  )
                }
                </div>
                
             
            </div>
          ),
        }
    
  ];


  const GridView = () => {
    if (loading) {
      return (
        <SkeltonLoader
          number={pageSettings?.pageSize}
          active={true}
          className="col-md-4 col-sm-6 col-12 col-lg-4 col-xl-3 p-2"
        />
      );
    } else {
      return (
        <>
          {assetData.map((asset, index) => (
            <div
              className="col-md-6 col-sm-12 col-lg-6 col-xl-4 col-xxl-3"
              key={asset.id}
            >
              <div className="profile-widget">
                <div className="dropdown profile-action">
                  <div className="dropdown dropdown-action">
                    <Link
                      to="#"
                      className="action-icon dropdown-toggle"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i className="material-icons">more_vert</i>
                    </Link>
                    <div className="dropdown-menu dropdown-menu-right">
                      <Link
                        onClick={() => {
                          setReturnAssetModal(true)
                          setSelectedAsset(asset)
                        }}
                        to="#"
                        className="dropdown-item"
                      >
                        <i className="fa fa-trash m-r-5" /> Return Asset
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-4">
                    <div className="profile-img">
                      <a className="avatar">
                        <Image 
                          src={asset?.image} 
                          type="user" 
                          alt="Asset Image" 
                          style={{ 
                            width: "100%", 
                            height: "100%", 
                            objectFit: "contain", 
                            borderRadius: "4px" 
                          }} 
                        />
                      </a>
                    </div>
                  </div>
                  <div className="col-8">
                    <h4 className="user-name m-t-10 mb-0 text-ellipsis text-start">
                      <a onClick={() => handleAssetDetailPage(asset.id, index)}>
                        {asset.name}
                      </a>
                      <span>{asset?.class_code}</span>
                    </h4>
                    <div className="small text-muted text-start">
                      <strong>Brand:</strong> <span className="badge badge-soft-warning">{asset.brand}</span>
                    </div>
                    <div className="small text-muted text-start"><strong>Serial #:</strong> {asset.serial_number}</div>
                    <div className="small text-muted text-start">
                      <strong>Current Owner:</strong> {asset.current_owner ? 
                        `${asset.current_owner?.company_user?.first_name} ${asset.current_owner?.company_user?.last_name} (${asset.current_owner?.company_user?.emp_no})` 
                        : "N/A"}
                    </div>
                    {/* <div className="small text-muted text-start">
                      <strong>Return Date:</strong> {formatDateHandler2(asset?.return_date) || "-"}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Next Approver:</strong> {asset?.next_approver || "N/A"}
                    </div> */}
                    
                    <div className="small text-muted text-start">
                      <strong>Purchase Date:</strong> {formatDateHandler2(asset?.purchase_date) || "-"}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>Purchase Value:</strong> {asset.purchase_value}
                    </div>
                    <div className="small text-muted text-start">
                      <strong>FA No:</strong> {asset.ext_id}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </>
      );
    }
  };


  const returnAssetHandler = (returnData) => {
    console.log(selectedAsset, "LLLLLLLL")
    returnAssetApi(selectedAsset?.current_owner?.id, returnData).then(res=>{
      toast.success('Asset return request initiated successfully!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
        getAssetList()
        setReturnAssetModal(false)
    }).catch(e=>{
      toast.error('Error initiating asset return!', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
        transition: Bounce,
        });
    })
  }


  return (
    <div>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <Breadcrumbs
            maintitle="Assets"
            title="Dashboard"
            subtitle="Assets"
            modal="#add_assets"
            name="Add Assets"          
            view={view}
            setAssetModal={setAssetModal}
            setView={setView}
          />

          <AssetListFilter
           filters={filters} 
           handleInputChange={handleInputChange} 
           searchPlaceholder={"Search Assets"} 
           handleFilterDrawer={handleFilterDrawer}
            handleFilterChange={handleFilterChange}
            loading={loading}
          />



          {view == "grid" ? (
            <div className="row">    
              <GridView />
              <div className="my-2 d-flex justify-content-end ">
                <div className="col-sm-12 col-md-6 ">
                <Pagination
                    pageSize={pageSettings?.pageSize}
                    pageSizeOptions={pageSizeOptions}
                    defaultCurrent={1}
                    current={pageSettings?.page}
                    total={pageSettings?.total}
                    // itemRender={itemRender}
                    onChange={handleGridChange}
                    showLessItems
                    showSizeChanger={false}
                    showQuickJumper={false}
                    hideOnSinglePage
                    itemRender={(page, type, originalElement) => {
                      if (type === "next") {
                        return (
                          <Button
                            loading={loading}
                            // disabled={loading || (selectedLeavePlanner && selectedLeavePlanner?.leave_planner?.company_user?.id != user?.id)}
                            className="btn btn-primary "
                            // type="Load More"
                            label="Load More"
                          />
                        );
                      }
                      return null;
                    }}
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="table-responsive">
                {/* <SearchBox pageSettings={pageSettings} setPageSettings={setPageSettings} /> */}
                <Table
                // scroll={{ x: "max-content", y: "max-content" }} // 👈 Keeps horizontal scrollbar
                  className="table-striped"
                  columns={columns}
                  dataSource={assetData}
                  rowKey={(record) => record.id}
                  loading={loading}
                  pagination={{
                    total: pageSettings?.total,
                    pageSize: pageSettings?.pageSize,
                    showSizeChanger: true,
                    pageSizeOptions: pageSizeOptions,
                    // showQuickJumper: true,
                    itemRender: itemRender,
                    position: "right",
                    current: pageSettings?.page,
                    showTotal: (total, range) =>
                      `${range[0]}-${range[1]} of ${total} items`,
                  }}
                  onChange={handleChange}
                />
              </div>
            </div>
          )}
        </div>
      </div>

     

      <AssetFilterDrawer
          searchPlaceholder={"Search Asset"}
          showFilterDrawer={showFilterDrawer}
          handleFilterDrawer={handleFilterDrawer}

          handleFilterChange={handleFilterChange}
          filters={filters}
          handleInputChange={handleInputChange}
          handleApplyFilter={handleApplyFilter}
          filterLoading={filterLoading}
          handleDateChange={handleDateChange}
        />
      
      <AllAssetAddPopup getAssetList={getAssetList} assetCategory={assetCategory} setSelectedAsset={setSelectedAsset} setLoading={setLoading} selectedAsset={selectedAsset} loading={loading} assetModal={assetModal} setAssetModal={setAssetModal} />




      <ReturnAssetModal returnAssetModal={returnAssetModal} setReturnAssetModal={setReturnAssetModal} returnAssetHandler={returnAssetHandler} Name="Return Asset" />

    </div>
  );
};

export default AllAssets;
